
import Tracker from "@/views/Tracker";
import Verbatims from "@/views/Verbatims";
import ZoomCategory from "@/views/ZoomCategory";
import Vue from "vue";
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Tracker,
        meta: {
        }
    },
    {
        path: '/trackers/:id/:cat',
        component: ZoomCategory,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/verbatims/:id/:step',
        component: Verbatims,
        meta: {
            requiresAuth: true
        }
    }
]

const router = new VueRouter({
    routes,
})

router.beforeEach((to, from, next) => {
    /*const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth) {
        next('/sign-in');
    } else {
        next();
    }*/
    next();
});

router.beforeEach((to, from, next) => {
    //document.title = to.meta.title
    next()
})

export default router